import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  module: null,
};

const loadingSlice = createSlice({
  name: 'loading',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setModuleLoading: (state, action) => {
      state.module = action.payload;
    },
  },
});

export const { setLoading, setModuleLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
